import { Card, CardBody, Col } from "reactstrap";
import { ShippingDetails } from "./ShippingDetails";
import { Brand } from "../../../../../Constants/Constants";
import { H5, LI, UL } from "../../../../../AbstractElements";

const BrandDetail = () => {
const Brands:string[]= ["Clothing","Bags","Footwear","Watches","ACCESSORIES"]

  return (
    <Col xxl="3" md="6" className="box-col-12">
      <Card>
        <CardBody>
          <div className="filter-block">
            <H5>{Brand}</H5>
            <UL className="simple-list">
              {Brands.map((item, index) => (
                <LI key={index}>{item}</LI>
              ))}
            </UL>
          </div>
        </CardBody>
      </Card>
      <ShippingDetails />
    </Col>
  );
};

export default BrandDetail;